import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

const QuizFilters = ({ statusFilter, setStatusFilter }) => {
  return (
    <Row className="mt-4">
      <Col md="12">
        <FormGroup>
          <Label>Lọc theo trạng thái</Label>
          <Input 
            type="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="border-0 shadow-sm"
          >
            <option value="all">Tất cả</option>
            <option value="active">Đang hoạt động</option>
            <option value="inactive">Không hoạt động</option>
          </Input>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default QuizFilters;

